export default {
    state: {
        currentRound: 0,
        roundCount: 0,
        data: null,
        type: ""
    },
    mutations: {
        initiateStage(state) {
            state.currentRound = 0;
        },

        setStageType(state, type) {
            state.type = type;
        },

        setCurrentRound(state, int) {
            state.currentRound = int;
        },

        setRoundCount(state, int) {
            state.roundCount = int;
        },

        setStageData(state, stageData) {
            state.data = stageData;
        }
    },
    actions: {
        setStageData(store, data) {
            return new Promise((resolve, reject) => {
                let stageType = data.type;

                let roundCount = 0;
                let roundData = null;

                if (stageType == "Rounds") {
                    roundCount = data.data.rounds.length;
                    roundData = data.data.rounds[store.state.currentRound];
                }
                //console.log(stageType);
                //console.log(data);
                store.commit("initiateStage");
                store.commit("setStageType", stageType);
                store.commit("setRoundCount", roundCount);
                store.commit("setStageData", data.data);
                store.dispatch("setRoundData", roundData).then(() => {
                    resolve();
                });
            });
        },

        toNextRound(store) {
            return new Promise((resolve, reject) => {
                store.commit("setCurrentRound", store.state.currentRound + 1);
                let roundData =
                    store.state.data == null || store.state.data.rounds == null
                        ? null
                        : store.state.data.rounds[store.state.currentRound];
                store.dispatch("setRoundData", roundData).then(() => {
                    resolve();
                });
            });
        }
    },
    getters: {
        stageData(state) {
            return state.data;
        },
        currentRound(state) {
            return state.currentRound;
        },
        roundCount(state) {
            return state.roundCount;
        },
        lastRound(state) {
            return state.currentRound >= state.roundCount - 1;
        },
        stageType(state) {
            return state.type;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/stage.js